// extracted by mini-css-extract-plugin
export default {"score-modifier":"ScoreModifier_score-modifier__7Pzc7","score-modifiers":"ScoreModifier_score-modifiers__6OOpQ"};